import { render } from "./EtatPointVente.vue?vue&type=template&id=0ade65fc&ts=true"
import script from "./EtatPointVente.vue?vue&type=script&lang=ts"
export * from "./EtatPointVente.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__